import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableHeader, TableRow, TableCell, TableBody } from '@/components/ui/table';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const TeklifGecmisi = () => {
  const [teklifler, setTeklifler] = useState([]);

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('teklifGecmisi')) || [];
    setTeklifler(veriler);
  }, []);

  const handlePDFDownload = (teklif) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Teklif PDF`, 14, 20);
    doc.setFontSize(12);

    autoTable(doc, {
      head: [['Konu', 'Alıcı', 'Tarih', 'Mesaj']],
      body: [[teklif.konu, teklif.aliciEmail, teklif.tarih || '-', teklif.mesaj]],
    });

    doc.save(`teklif_${teklif.konu}.pdf`);
  };

  return (
    <div className="max-w-6xl mx-auto">
      <Card>
        <CardContent className="space-y-6">
          <h2 className="text-2xl font-bold">🗂️ Gönderilen Teklifler</h2>
          {teklifler.length === 0 ? (
            <p className="text-gray-500">Henüz kayıtlı teklif yok.</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell>Konu</TableCell>
                  <TableCell>Alıcı E-posta</TableCell>
                  <TableCell>Tarih</TableCell>
                  <TableCell>Mesaj</TableCell>
                  <TableCell>İşlem</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {teklifler.map((teklif, index) => (
                  <TableRow key={index}>
                    <TableCell>{teklif.konu}</TableCell>
                    <TableCell>{teklif.aliciEmail}</TableCell>
                    <TableCell>{teklif.tarih || '-'}</TableCell>
                    <TableCell>{teklif.mesaj?.slice(0, 50) + '...'}</TableCell>
                    <TableCell>
                      <Button size="sm" onClick={() => handlePDFDownload(teklif)}>
                        PDF İndir
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TeklifGecmisi;
